angular.
module("dx.webapp.masterTools").
controller("DxRecalculateExamRouteController", function recalculateExam(
	dxApi
) {
	"use strict";

	var self = this;

	self.examId = "";
	self.message = "";
	self.error = false;

	self.recalculate = function recalculate() {
		dxApi.v1.exams.recalculate(self.examId).then(function onSuccess() {
			self.error = false;
			self.message = "Recalculated exam " + self.examId + " successfully";
			self.examId = "";
		}, function onFail(response) {
			self.error = true;
			self.message = "Error recalculating exam " + self.examId + ": " + response.data.message;
			self.examId = "";
		});
	};

	self.examIdChange = function examIdChange() {
		if (self.validExamId() || self.examId.length === 0) {
			self.message = "";
		} else {
			self.error = true;
			self.message = "An exam id can only consist of numbers";
		}
	};

	self.validExamId = function validExamId() {
		return self.examId.length > 0 && !isNaN(self.examId);
	};
});
